export default __webpack_public_path__ + "static/media/learose3-2048w.cc5fc714.webp";